import {
  Component, OnInit, ViewChild, Input, Output, EventEmitter, AfterViewInit,
} from '@angular/core';
import { UploaderComponent } from '@syncfusion/ej2-angular-inputs';
import { EmitType, detach } from '@syncfusion/ej2-base';
import { SettingsService } from '../../../shared/services';
import { ToastrService } from 'ngx-toastr';
import { AsyncSettingsModel } from '@syncfusion/ej2-inputs/src/uploader/uploader-model';
import { createSpinner } from '@syncfusion/ej2-angular-popups';
import { showSpinner, hideSpinner } from '@syncfusion/ej2-popups';

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss'],
    standalone: false
})
export class FileUploadComponent implements OnInit, AfterViewInit {
  @ViewChild('defaultupload')
    uploadObj: UploaderComponent;
  dropElement: HTMLElement;
  uploadSettings: AsyncSettingsModel;

  @Input() saveUrl: string;
  @Input() fileMaxSize: number | undefined;
  @Input() fileMinSize: number | undefined;
  @Input() autoUploadEnabled = true;
  @Input() multipleFileMode = false;
  @Input() iconClassName = 'fa-file-excel';
  @Input() formatDisplayText = 'Zip (.zip) format only';
  @Input() allowExtensions = '.zip';
  @Input() maxDropAreaHeight;
  @Input() sequentialUpload = false;
  @Input() disabled = false; // Disable the upload control when form is invalid
  @Output() uploading: EventEmitter<Object> = new EventEmitter<Object>();
  @Output() success: EventEmitter<Object> = new EventEmitter<Object>();
  @Output() failure: EventEmitter<Object> = new EventEmitter<Object>();
  totalFiles = -1;
  uploadedFiles = 0;

  constructor(private settingsService: SettingsService, private toastr: ToastrService) { }

  ngOnInit(): void {
    this.uploadSettings = {
      saveUrl: this.saveUrl,
    };
    const settings = this.settingsService.getSettings();
    if (!this.fileMinSize) {
      this.fileMinSize = settings.FileMinSize;
    }

    if (!this.fileMaxSize) {
      this.fileMaxSize = settings.FileMaxSize;
    }

    this.totalFiles = -1;
    this.uploadedFiles = 0;
    this.settingsService.UpdateLoading(false);
  }

  ngAfterViewInit() {
    if (this.uploadObj) {
      this.uploadObj.dropArea = document.getElementById('dropTarget');

      document.getElementById('droppingArea').onclick = (e: any) => {
        const target: HTMLElement = <HTMLElement>e.target;
        if (target.classList.contains('e-file-delete-btn')) {
          for (let i = 0; i < this.uploadObj.getFilesData().length; i++) {
            if (target.parentElement.getAttribute('data-file-name') === this.uploadObj.getFilesData()[i].name) {
              this.uploadObj.remove(this.uploadObj.getFilesData()[i]);
            }
          }
        } else if (target.classList.contains('e-file-remove-btn')) {
          detach(target.parentElement);
        }
      };
    }
  }

  public browseClick() {
    document?.getElementsByClassName('e-file-select-wrap')[0]?.querySelector('button')?.click();
    return false;
  }

  public addHeaders(args: any) {
    args.currentRequest.setRequestHeader('Access-Control-Allow-Origin', '*');
  }

  public onUploading: EmitType<Object> = (args: any) => {
    // internal logic
    this.addHeaders(args);

    // Check file size
    const fileData = args.fileData;
    if (fileData.size > this.fileMaxSize || fileData.size < this.fileMinSize) {
      this.toastr.show('File size should not be smaller than ' + this.fileMinSize + ' and larger than ' + this.fileMaxSize + 'bytes');
      args.cancel = true;
    }

    // suppress event if canceling in internal method
    if (!args.cancel) {
      this.uploading?.emit(args);
    }
  };

  public onSuccess: EmitType<Object> = (args: any) => {
    setTimeout(() => {
      this.uploadObj.remove(args.file);

		}, 3000);

    this.success?.emit(args);
    this.allFilesUploadedCheck();
  };

  public onfailure: EmitType<Object> = (args: any) => {
    // future internal logic

    this.failure?.emit(args);
    this.allFilesUploadedCheck();
  };

  onFileSelected: EmitType<Object> = (args: any) => {
    this.uploadedFiles = 0; 

    this.totalFiles = args.filesData.length;
    this.settingsService.UpdateLoading(true);
    let all = this.uploadObj.getFilesData();

    const filteredList = all.filter(obj1 => {
      return args.filesData.some(obj2 => obj1.name === obj2.name);
    });

    if (filteredList.length > 0) {
      this.uploadObj.remove(filteredList);
    }
  
  }

  public onFailure(args: any): void {
    let response = JSON.parse(args.e.currentTarget.response);
    args.statusText = response.message;
  }

  allFilesUploadedCheck() {
    this.uploadedFiles++;
    if (this.uploadedFiles === this.totalFiles) {
      this.settingsService.UpdateLoading(false);
      this.totalFiles = -1;
      this.uploadedFiles = 0;
    }
  }
}
